import type { FC } from 'react';
import type { IconProps } from './types';

const FilePpt: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.5, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 24) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20 13V10.6569C20 9.83935 20 9.4306 19.8478 9.06306C19.6955 8.69552 19.4065 8.40649 18.8284 7.82843L14.0919 3.09188C13.593 2.593 13.3436 2.34355 13.0345 2.19575C12.9702 2.165 12.9044 2.13772 12.8372 2.11401C12.5141 2 12.1614 2 11.4558 2C8.21082 2 6.58831 2 5.48933 2.88607C5.26731 3.06508 5.06508 3.26731 4.88607 3.48933C4 4.58831 4 6.21082 4 9.45584V13M13 2.5V3C13 5.82843 13 7.24264 13.8787 8.12132C14.7574 9 16.1716 9 19 9H19.5" />
      <path d="M4 22V19M4 19V16H6C6.82843 16 7.5 16.6716 7.5 17.5C7.5 18.3284 6.82843 19 6 19H4ZM10 22V19M10 19V16H12C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19H10ZM16 16H18M18 16H20M18 16V22" />
    </svg>
  );
};

export default FilePpt;
